import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

let deferredPrompt;

window.addEventListener("beforeinstallprompt", (e) => {
  // Prevent the default mini-info bar or install prompt
  e.preventDefault();
  // Save the event for later use
  deferredPrompt = e;

  // Optionally show your custom "install" button here
  const installButton = document.querySelector("#install-button");
  installButton.style.display = "block";

  installButton.addEventListener("click", () => {
    // Show the prompt
    deferredPrompt.prompt();
    // Wait for the user's response to the prompt
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the A2HS prompt");
      } else {
        console.log("User dismissed the A2HS prompt");
      }
      deferredPrompt = null;
    });
  });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
